import { render, staticRenderFns } from "./document-history-dialog.vue?vue&type=template&id=c4b7273a&scoped=true&lang=pug&"
import script from "./document-history-dialog.vue?vue&type=script&lang=ts&"
export * from "./document-history-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./document-history-dialog.vue?vue&type=style&index=0&id=c4b7273a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b7273a",
  null
  
)

export default component.exports